import { Interface } from 'ethers/lib/utils.js';
import type { IConnectorReturnData } from '../types';
import { MATCHA_CONNECTOR } from './constants';
import abi from '../abi';
import type BigNumber from 'bignumber.js';

export function matchaSwapConnector(
	from: `0x${string}`,
	to: `0x${string}`,
	amt: BigNumber,
	minReceived: BigNumber,
	calldata: string,
	setId: number
): IConnectorReturnData {
	const matchaInterface = new Interface(abi.scWalletMatcha);
	return {
		_target: MATCHA_CONNECTOR,
		_callData: matchaInterface.encodeFunctionData('swap', [
			from,
			to,
			amt.toFixed(0),
			minReceived.toFixed(0),
			calldata,
			setId
		])
	};
}
